module.exports = __webpack_public_path__ + "img/create_new_content_type.f3f0dc6b.png";